import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminSettingsRoutingModule } from './admin-settings-routing.module';
import { SettingsComponent } from './settings/settings.component';
import { BulkOperationComponent } from './bulk-operation/bulk-operation.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { QuillModule } from 'ngx-quill';


@NgModule({
  declarations: [
    SettingsComponent,
    BulkOperationComponent
  ],
  imports: [
    CommonModule,
    AdminSettingsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NgxSpinnerModule,
    NgxDatatableModule,
    PipeModule,
    QuillModule.forRoot(),

  ]
})
export class AdminSettingsModule { }
